import { Theme } from '@mui/material';

const useStyles = (theme: Theme) => ({
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: 'min(450px, 100vw - 32px)',
    gap: '16px',
    padding: '16px',
    maxHeight: '600px',
    overflowY: 'scroll',
    overflowX: 'hidden',
  },
  controllerWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  footer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    padding: '16px',
    mt: '10px',
  },
  footerWrapper: {
    display: 'flex',
    width: '100%',
    gap: '8px',
  },
});

export default useStyles;
